<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ titleWord }} {{ t("Repertoire") }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="repertoireName.length == 0 || (props.action == 'edit' && editPercentage == 0)" @click="confirm" :strong="true">{{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-item class="ion-text-wrap">
      <span class="labelWidth">{{ repertoireNameLabel }}</span>
      <ion-input label-placement="fixed"
                  :placeholder="placeHolderString" :value="repertoireName"
                  @ionInput="nameChange">
      </ion-input>
    </ion-item>
    <ion-item v-if="props.action == 'add'">
    <ion-radio-group value="white" @ionChange="colorChange($event)">
      
      <ion-radio value="white" aria-label="White" label-placement="start">
        {{ t("Color") }}:  {{ t("White") }}
      </ion-radio>
      <ion-radio value="black" aria-label="Black" label-placement="start">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ t("Black") }}
      </ion-radio>
  </ion-radio-group>
  </ion-item>
    <ion-item>
      <ion-label class="ion-text-center labelWidth">
       <h2>{{ t("Rating Range") }}:<br>{{ minNumber }} {{ t("to") }} {{  maxNumber }}</h2>
      </ion-label>
      <ion-range :pin="true" aria-label="Dual Knobs Range" :dual-knobs="true" :min="800" :max="2550" :step="50"   v-model="value"
      @ionKnobMoveStart="onIonKnobMoveStart"
    @ionKnobMoveEnd="onIonKnobMoveEnd"
      ></ion-range>
      </ion-item>
<br>
      <ion-item v-if="props.action == 'add'" class="ion-text-wrap">
        <ion-label class="ion-text-center">
          {{ t("Percentage Filter") }} : {{ addPercentageArray[addPercentageFilter].percent }}%
          <br>
          <i>{{ addPercentageArray[addPercentageFilter].ratio }} 
          </i>     
        </ion-label>
        <ion-range aria-label="Percentage Filter" :ticks="true"    
                          :snaps="true" v-model="addPercentageFilter"
                          :min="0" :max="10" :step="1" class="move_slider_style"
                          @ionChange="percentageChange">
                  </ion-range>
    </ion-item>
    <ion-item v-if="props.action == 'edit'">
      <span class="labelWidth">{{  percentageLabelString }}</span>
      <ion-input label-placement="fixed" type="number"
                  min=".001" max="5" step=".001"
                  :value="editPercentage"
                  @ionInput="editPercentageChange">
      </ion-input>
    </ion-item>
  </ion-content>
</template>

<script  setup>
  import {
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t } from '@/composables/translateText.js'

  const props = defineProps({
    action : String,
    min : Number,
    max : Number,
    name : String,
    color : String,
    editPercentage : Number
	})

  const percentageLabelString = t("Percentage")
  const gameInA = t("game in a")
  const addPercentageArray = ref([ 
          { percent : .1, ratio : "1 " + gameInA + " 1,000" },
          { percent : .2, ratio : "1 " + gameInA + " 500" },
          { percent : .25, ratio : "1 " + gameInA + " 400" },
          { percent : .4, ratio : "1 " + gameInA + " 250" },
          { percent : .5, ratio : "1 " + gameInA + " 200" },
          { percent : .67, ratio : "1 " + gameInA + " 150" },
          { percent : 1, ratio : "1 " + gameInA + " 100" },
          { percent : 2, ratio : "1 " + gameInA + " 50" },
          { percent : 3, ratio : "1 " + gameInA + " 33" },
          { percent : 4, ratio : "1 " + gameInA + " 25" },
          { percent : 5, ratio : "1 " + gameInA + " 20" }
        ])

  const name = ref();
  const titleWord = ref( (props.action == "add") ? t("Add") : t("Edit"))
  
  const placeHolderString = ref(t("Enter name"))

  var value = {lower: props.min, upper: props.max}
  const minNumber = ref(value.lower)
  const maxNumber = ref(value.upper)
  const repertoireNameLabel = ref((props.action == "add") ? t("Repertoire Name") : t("Name"))
  const repertoireName = ref(props.name)
  const color = ref(props.color)
  const editPercentage = ref(props.editPercentage)
  const addPercentageFilter = ref(6)

  const cancel = () => modalController.dismiss(null, 'cancel');

  function confirm() {
    var result = { 
                action : props.action,
                min : minNumber.value,
                max : maxNumber.value,
                name : repertoireName.value,
                color : color.value,
                editPercentage : editPercentage.value,
                percent : addPercentageArray.value[addPercentageFilter.value].percent
    }

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function onIonKnobMoveStart({ detail }) {
    //console.log('ionKnobMoveStart:', detail.value);
    //console.log("value is ",value)
    minNumber.value = value.lower
    maxNumber.value = value.upper
  }
  function onIonKnobMoveEnd({ detail }) {
    //console.log('ionKnobMoveEnd:', detail.value);
    //console.log("value is ",value)
    minNumber.value = value.lower
    maxNumber.value = value.upper
  }

  function nameChange(ev) {
    //console.log("name ",ev)
    const value = ev.target.value;
    //console.log("repertoire name ",value)
    repertoireName.value = value.trim()
  }

  function editPercentageChange(ev) {
    //console.log("edit percentage ",ev)
    const value = ev.target.value;
    //console.log("percentage ",value)
    editPercentage.value = value.trim()
  }

  function colorChange(ev) {
    //console.log("color Change",ev.detail)
    //console.log('Current value:', JSON.stringify(ev.detail.value));
    color.value = ev.detail.value
  }

  function percentageChange({ detail }) {
    addPercentageFilter.value = detail.value
  }
</script>

<style scoped>

ion-radio::part(container) {
    width: 30px;
    height: 30px;

    border-radius: 8px;
    border: 2px solid #ddd;
  }

  ion-radio::part(mark) {
    background: none;
    transition: none;
    transform: none;
    border-radius: 0;
  }

  ion-radio.radio-checked::part(container) {
    background: #6815ec;
    border-color: transparent;
  }

  ion-radio.radio-checked::part(mark) {
    width: 6px;
    height: 10px;

    border-width: 0px 2px 2px 0px;
    border-style: solid;
    border-color: #fff;

    transform: rotate(45deg);
  }

  .labelWidth {
    width: 250px;
  }
</style>
